<template>
    <div class="trade-list-page-view">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>
                            <v-icon color="primary">currency_exchange</v-icon>
                            <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                                Trade List
                            </p>
                            <v-spacer></v-spacer>
                            <v-btn depressed rounded class="primary lighten-1" @click="() => (createDialog = true)">
                                <v-icon>add</v-icon>
                                create new trade
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-data-table :page="page" :pageCount="numberOfPages" :search="search" :loading="loading"
                                :headers="headers" :items="trades" :items-per-page="itemsPerPage"
                                :options.sync="options" mobile-breakpoint="0" :server-items-length="totalCount">
                                <template v-slot:[`item.transferBy.name`]="{ item }">
                                    <p
                                        class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4">
                                        {{ item.transferBy.name }}</p>
                                </template>
                                <template v-slot:[`item.fromAccount.bankName`]="{ item }">
                                    <p
                                        class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4">
                                        {{ item.fromAccount.bankName }}</p>
                                </template>
                                <template v-slot:[`item.receiveAccount.bankName`]="{ item }">
                                    <p
                                        class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4">
                                        {{ item.receiveAccount.bankName }}</p>
                                </template>
                                <template v-slot:[`item.owned`]="{ item }">
                                    <v-chip small dark :color="item.owned ? 'primary' : 'orange'">{{
                                        item.owned ? "Owned" : "Not-Owned" }}</v-chip> </template>
                                <template v-slot:[`item.amountTHB`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.amountTHB }}</p>
                                </template>
                                <template v-slot:[`item.amountMMK`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.amountTHB }}</p>
                                </template>
                                <template v-slot:[`item.status`]="{ item }">
                                    <v-chip v-if="item.status == 'ongoing'" small dark color="orange">Ongoing</v-chip>
                                    <v-chip v-if="item.status == 'success'" small dark color="green">Success</v-chip>
                                    <v-chip v-if="item.status == 'cancelled'" small dark color="red">Canceled</v-chip>
                                </template>
                                <template v-slot:[`item.createdAt`]="{ item }">
                                    <p class="number text--secondary mt-4 text-caption">{{ new
                                        Date(item.createdAt).toLocaleString()
                                        }}</p>
                                </template>
                                <template v-slot:[`item.update`]="{ item }">
                                    <v-btn icon @click="() => handleShowUpdateDialog(item)"
                                        class="text-secondary"><v-icon>edit</v-icon></v-btn>
                                </template>
                                <template v-slot:[`item.delete`]="{ item }">
                                    <v-btn icon @click="
                                        () => {
                                            deleteDialog = true;
                                            selectedItem = item._id;
                                        }
                                    " class="text-secondary"><v-icon>delete</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="createDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="primary">currency_exchange</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                        Create A New Trade
                    </p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete dense v-model="trader" :items="traders" :loading="traderLoading"
                                class="text-body-2" filled rounded hide-no-data item-text="name" item-value="_id"
                                label="Search traders" placeholder="Start typing to search..."
                                prepend-inner-icon="search" return-object />
                            <v-autocomplete dense v-model="senderBankAccount" :items="senderBankAccounts"
                                :loading="senderBankAccountLoading" class="text-body-2" filled rounded hide-no-data
                                item-text="bankName" item-value="_id" label="Search sender bank accounts"
                                placeholder="Start typing to search..." prepend-inner-icon="search" return-object />
                            <v-autocomplete dense v-model="bankAccount" :items="bankAccounts"
                                :loading="bankAccountLoading" class="text-body-2" filled rounded hide-no-data
                                item-text="bankName" item-value="_id" label="Search bank accounts"
                                placeholder="Start typing to search..." prepend-inner-icon="search" return-object />
                            <v-text-field label="Amount (THB)" placeholder="Enter THB amount" filled rounded x-large
                                type="number" v-model="amountTHB" />
                            <v-text-field label="Amount (MMK)" placeholder="Enter MMK amount" filled rounded x-large
                                type="number" v-model="amountMMK" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (createDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text x-large :loading="addLoading" @click="handleAddNew">
                        <v-icon>save</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="primary">currency_exchange</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                        Update Trade
                    </p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete dense v-model="trader" :items="traders" :loading="traderLoading"
                                class="text-body-2" filled rounded hide-no-data item-text="name" item-value="_id"
                                label="Search traders" placeholder="Start typing to search..."
                                prepend-inner-icon="search" return-object />
                            <v-autocomplete dense v-model="senderBankAccount" :items="senderBankAccounts"
                                :loading="senderBankAccountLoading" class="text-body-2" filled rounded hide-no-data
                                item-text="bankName" item-value="_id" label="Search sender bank accounts"
                                placeholder="Start typing to search..." prepend-inner-icon="search" return-object />
                            <v-autocomplete dense v-model="bankAccount" :items="bankAccounts"
                                :loading="bankAccountLoading" class="text-body-2" filled rounded hide-no-data
                                item-text="bankName" item-value="_id" label="Search bank accounts"
                                placeholder="Start typing to search..." prepend-inner-icon="search" return-object />
                            <v-text-field label="Amount (THB)" placeholder="Enter THB amount" filled rounded x-large
                                type="number" v-model="amountTHB" />
                            <v-text-field label="Amount (MMK)" placeholder="Enter MMK amount" filled rounded x-large
                                type="number" v-model="amountMMK" />
                            <v-select label="Status" v-model="status" class="select mx-2 my-1" :items="allStatus" filled
                                rounded dense item-text="name" item-value="value"></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (updateDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text x-large :loading="updateLoading" @click="handleUpdate">
                        <v-icon>save</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="red">warning</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold red--text">Warning</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    Please confirm that you want to delete this trade.This action can't be
                    revert.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (deleteDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text x-large :loading="deleteLoading" @click="handleDeleteTrade">
                        <v-icon>delete</v-icon>
                        delete trade
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { tradeApi, traderApi, senderBankAccountApi, bankAccountApi } from "@/api"

export default {
    name: "TradeListPageView",
    data: function () {
        return {
            page: 1,
            numberOfPages: null,
            search: null,
            loading: false,
            trades: [],
            senderBankAccounts: [],
            bankAccounts: [],
            itemsPerPage: 10,
            totalCount: null,
            options: {},
            headers: [
                { text: "Transfer By", value: "transferBy.name" },
                { text: "From Account", value: "fromAccount.bankName" },
                { text: "Receive Account", value: "receiveAccount.bankName" },
                { text: "Owned", value: "owned" },
                { text: "Amount (THB)", value: "amountTHB" },
                { text: "Status", value: "status" },
                { text: "Date", value: "createdAt" },
                { text: "Update", value: "update" },
                { text: "Delete", value: "delete" },
            ],
            allStatus: [{
                name: "On-Going",
                value: "ongoing"
            }, {
                name: "Success",
                value: "success"
            }, {
                name: "Cancelled",
                value: "cancelled"
            }],
            createDialog: false,
            addLoading: false,
            deleteDialog: false,
            deleteLoading: false,
            selectedItem: null,
            updateDialog: false,
            updateLoading: false,
            searchText: "",
            traderLoading: false,
            senderBankAccountLoading: false,
            bankAccountLoading: false,
            traderFilter: "",
            trader: "",
            senderBankAccountFilter: "",
            senderBankAccount: "",
            bankAccountFilter: "",
            bankAccount: "",
            amountTHB: "",
            amountMMK: "",
            status: null
        };
    },
    methods: {
        handleAddNew: async function () {
            this.addLoading = true;

            const trade = {
                transferBy: this.trader._id,
                fromAccount: this.senderBankAccount._id,
                receiveAccount: this.bankAccount._id,
                amountTHB: this.amountTHB,
                amountMMK: this.amountMMK || 0,
            }

            try {
                await tradeApi.createTrade(trade);
                this.readData(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }

            this.addLoading = false;
            this.createDialog = false;
        },
        handleUpdate: async function () {
            this.updateLoading = true;

            const trade = {
                transferBy: this.trader._id,
                fromAccount: this.senderBankAccount._id,
                receiveAccount: this.bankAccount._id,
                amountTHB: this.amountTHB,
                amountMMK: this.amountMMK,
                status: this.status
            }

            try {
                await tradeApi.updateTrade(this.selectedItem, trade);
                this.readData(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }

            this.updateLoading = false;
            this.updateDialog = false;
        },
        handleShowUpdateDialog: function (item) {
            this.selectedItem = item._id;
            this.trader = item.transferBy;
            this.senderBankAccount = item.fromAccount;
            this.bankAccount = item.receiveAccount;
            this.amountTHB = item.amountTHB;
            this.amountMMK = item.amountMMK;
            this.status = item.status;

            this.updateDialog = true;
        },
        loadTraders: async function () {
            this.traderLoading = true;
            try {
                const data = await traderApi.getTraders();
                this.traders = data.traders;
            } catch (error) {
                console.log(error);
            }
            this.traderLoading = false;
        },
        loadSenderBankAccounts: async function () {
            this.senderBankAccountLoading = true;
            try {
                const data = await senderBankAccountApi.getSenderBankAccounts();
                console.log(data);

                this.senderBankAccounts = data.senderBankAccounts;
            } catch (error) {
                console.log(error);
            }
            this.senderBankAccountLoading = false;
        },
        loadBankAccounts: async function () {
            this.bankAccountLoading = true;
            try {
                const data = await bankAccountApi.getBankAccounts();
                this.bankAccounts = data.bankAccounts;
            } catch (error) {
                console.log(error);
            }
            this.bankAccountLoading = false;
        },
        readData: async function (page, limit) {
            this.loading = true;
            try {
                const data = await tradeApi.getTrades(page, limit);

                this.trades = data.trades;
                this.page = data.currentPage;
                this.numberOfPages = data.totalPages;
                this.totalCount = data.totalCount;
            } catch (error) {
                console.log(error);
            }
            this.loading = false;
        },
        handleDeleteTrade: async function () {
            this.deleteLoading = true;
            try {
                await tradeApi.deleteTrade(this.selectedItem);
                this.readData(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }
            this.deleteLoading = false;
            this.deleteDialog = false;
        }
    },
    created: function () {
        this.loadTraders();
        this.loadSenderBankAccounts();
        this.loadBankAccounts();
    },
    watch: {
        options: function (options) {
            this.readData(options.page, options.itemsPerPage);
        },
    },
    computed: {
        // token: function () {
        //     return this.$store.state.currentUser.token;
        // },
    },
};
</script>
